<template>
    <div class="frc-captcha" />
</template>

<script>
import { WidgetInstance } from 'friendly-challenge';

export default {
    props: {
        siteKey: {
            type: String,
            required: true,
        },
        useEuEndpoint: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            captchaWidget: null,
        };
    },
    mounted() {
        const element = document.querySelector('.frc-captcha');

        const options = {
            startMode: 'focus',
            language: window.lang('sv', 'en'),
            sitekey: this.siteKey,
        };

        if (this.useEuEndpoint) {
            options['puzzleEndpoint'] = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle';
        }

        this.captchaWidget = new WidgetInstance(element, options);

        this.$EventBus.$on('resetCaptcha', () => this.captchaWidget.reset());
    },
};
</script>
